import { useGetOnboardingData } from "../../../data/usePortfolio";
import EntityOnboardingCard from "./EntityOnboardingCard";
import EntityOnboardingCardSkeleton from "./EntityOnboardingCardSkeleton";
import { ErrorPage } from "../ErrorPage";

type EntityOnboardingCardContainerProps = {
  compressed?: boolean;
};

export default function EntityOnboardingCardContainer({
  compressed = false,
}: EntityOnboardingCardContainerProps) {
  const onboarding = useGetOnboardingData();

  // Show skeleton on initial load (no data yet) or when refreshing after an error occurs
  if (onboarding.isFetching && (!onboarding.data || onboarding.isError)) {
    return <EntityOnboardingCardSkeleton compressed={compressed} />;
  }

  // Show error page if error
  if (onboarding.isError) {
    return (
      <ErrorPage
        errorCode={onboarding.error.correlationId}
        onRefresh={() => onboarding.refetch()}
      />
    );
  }

  if (onboarding.data) {
    // Show onboarding card with data
    return (
      <EntityOnboardingCard data={onboarding.data} compressed={compressed} />
    );
  }

  return null;
}
